<div class="filters-wrapper onboarding-filters">
    @if (isShowSkeleton) {
        <app-hotel-tours-filters-skeleton/>
    } @else if (filters) {
        <div class="filters-panel">
            @for (filter of filters; track filter.filterKey) {
                <div class="filter"
                     [ngClass]="{'active': isFilterActive(filter), 'open': openedFilter === filter.filterKey}"
                     (click)="toggleFilterDropdown(filter, $event)">
                    {{ getFilterDisplayName(filter) }}

                    @if (isFilterActive(filter)) {
                        <button class="reset-filter"
                                (click)="resetFilters($event, filter)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <rect y="6.10352e-05" width="15" height="15" rx="7.5" fill="#1B5AE7" fill-opacity="0.15"/>
                                <path
                                        d="M5.81426 5.13968C5.62804 4.95346 5.32611 4.95346 5.13988 5.13968C4.95366 5.32591 4.95366 5.62784 5.13988 5.81406L6.82571 7.49989L5.13967 9.18594C4.95344 9.37216 4.95344 9.67409 5.13967 9.86032C5.32589 10.0465 5.62782 10.0465 5.81405 9.86032L7.50009 8.17427L9.18615 9.86033C9.37238 10.0466 9.67431 10.0466 9.86053 9.86033C10.0468 9.67411 10.0468 9.37218 9.86053 9.18595L8.17447 7.49989L9.86032 5.81405C10.0465 5.62782 10.0465 5.32589 9.86032 5.13967C9.67409 4.95344 9.37216 4.95344 9.18594 5.13967L7.50009 6.82552L5.81426 5.13968Z"
                                        fill="#08286E" fill-opacity="0.5"/>
                            </svg>
                        </button>
                    }

                    @if (openedFilter === filter.filterKey) {
                        <div class="filter-dropdown" (click)="$event.stopPropagation()">
                            <div class="filter-list">
                                @for (filterValue of filter.values; track filterValue.filterValue) {
                                    <div class="pseudo-checkbox">
                                        <input type="checkbox"
                                               [value]="filterValue.filterValue"
                                               [checked]="isFilterSelected(filter.filterKey, filterValue.filterValue)"
                                               (change)="selectFilter($event, filter.filterKey, true)">
                                        <label>
                                            <span class="checkbox-box" aria-hidden="true"></span>
                                            @if (filter.filterKey === 'airlines') {
                                                <img [src]="getAirlineImageSrc(filterValue.filterValue)" class="airline-logo" alt=""/>
                                            }
                                            <div class="ng-value">{{ filterValue.viewValue }}</div>
                                        </label>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
